type teamMember = {
  name: string;
  description: string;
  // The image source is used in FlippableCard to find people's images.
  imageSource: string;
};

export const teamMembers = [
  {
    name: 'Adnan Benchaaboun',
    description:
      'Adnan Benchaaboun is a computer engineering major. \
      He enjoys reading and gaming. He also likes playing volleyball and tennis with his friends.',
    imageSource: require('../../assets/adnan.jpg'),
  },
  {
    name: 'Alex Yelovich',
    description:
      'Alex Yelovich is a math and computer science double major. \
      He once purchased a broken Wii U from a yard sale for $2 and repaired it to a working condition.',
    imageSource: require('../../assets/alex.jpg'),
  },
  {
    name: 'Avery Parker',
    description:
      'Avery Parker is a computer science and math double major. They enjoy playing Dungeons and Dragons.',
    imageSource: require('../../assets/avery.jpg'),
  },
  {
    name: 'Ayman Chowdhury',
    description:
      'Ayman Chowdhury is a computer science major. \
      He has the ability to snap incredibly loud.',
    imageSource: require('../../assets/ayman.jpg'),
  },
  {
    name: 'Julian Javillo',
    description:
      'Julian Javillo is a computer science major. \
      He likes to take photos, read, and plays the guitar.',
    imageSource: require('../../assets/julian.jpg'),
  },
  {
    name: 'Lucas LaBuff',
    description:
      'Lucas Labuff is a math and computer science double major. \
      He wears a cool hat.',
    imageSource: require('../../assets/lucas.png'),
  },
  {
    name: 'Sahil Gaba',
    description:
      'Sahil Gaba is a computer science major. \
      He enjoys gaming and going on long walks.',
    imageSource: require('../../assets/sahil.png'),
  },
];

export const mentors = [
  {
    name: 'Dana Dachman-Soled',
    description:
      'Dana Dachman-Soled is an associate professor in the \
      Department of Electrical and Computer Engineering at UMD. \
      She is a core faculty member in the \
      Maryland Cybersecurity Center.',
    role: 'Mentor',
    imageSource: require('../../assets/dana2.png'),
  },
  {
    name: 'Zaida Diaz',
    description:
      'Zaida is both a business and economics and also a \
      humanities and social sciences librarian at UMD. \
      She assists students and faculty at all points in their research process.',
    role: 'Librarian',
    imageSource: require('../../assets/zaida.png'),
  },
];
